<template>
  <div
    class="message-text__wrap"
    :class="{
      'show--quoted': showQuotedContent,
      'hide--quoted': !showQuotedContent,
      'reply-text': replyTo,
    }"
  >
    <div
      v-if="!isEmail"
      v-dompurify-html="cleanedMessage"
      class="text-content"
    />
    <letter v-else class="text-content" :html="cleanedMessage" />
    <button
      v-if="displayQuotedButton"
      class="quoted-text--button"
      @click="toggleQuotedContent"
    >
      <span v-if="showQuotedContent">
        <fluent-icon icon="chevron-up" class="fluent-icon" size="16" />
        {{ $t('CHAT_LIST.HIDE_QUOTED_TEXT') }}
      </span>
      <span v-else>
        <fluent-icon icon="chevron-down" class="fluent-icon" size="16" />
        {{ $t('CHAT_LIST.SHOW_QUOTED_TEXT') }}
      </span>
    </button>
  </div>
</template>

<script>
import Letter from 'vue-letter';

export default {
  components: { Letter },
  props: {
    message: {
      type: String,
      default: '',
    },
    replyTo: {
      type: Boolean,
      required: true,
    },
    isEmail: {
      type: Boolean,
      default: true,
    },
    displayQuotedButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showQuotedContent: false,
    };
  },
  computed: {
    /**
     * Propiedad computada que devuelve el mensaje con todas las etiquetas <img> eliminadas.
     *
     * @returns {String} La cadena de HTML limpia sin ninguna etiqueta <img>.
     */
    cleanedMessage() {
      return this.removeImgTags(this.message);
    },
  },
  methods: {
    toggleQuotedContent() {
      this.showQuotedContent = !this.showQuotedContent;
    },
    /**
     * Elimina todas las etiquetas <img> de una cadena de HTML.
     *
     * @param {String} htmlString - La cadena de HTML que contiene las etiquetas <img>.
     * @returns {String} La cadena de HTML sin las etiquetas <img>.
     */
    removeImgTags(htmlString) {
      return htmlString.replace(/<img[^>]*>/g, '');
    },
  },
};
</script>

<style lang="scss">
.reply-text {
  font-size: var(--font-size-mini);
  font-weight: var(--font-weight-bold);
  line-height: var(--font-size-default);
  text-align: left;
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-normal);
  line-height: var(--space-two);
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  white-space: normal;
  color: var(--conversa2-neutral-900-color);
  padding: 7px 0 4px 0;
}
.text-content {
  overflow: auto;

  ul,
  ol {
    padding-left: var(--space-two);
  }
  table {
    margin: 0;
    border: 0;

    td {
      margin: 0;
      border: 0;
    }

    tr {
      border-bottom: 0 !important;
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: var(--font-size-normal);
  }
}

.show--quoted {
  blockquote {
    display: block;
  }
}

.hide--quoted {
  blockquote {
    display: none;
  }
}

.quoted-text--button {
  color: var(--s-400);
  cursor: pointer;
  font-size: var(--font-size-mini);
  padding-bottom: var(--space-small);
  padding-top: var(--space-small);

  .fluent-icon {
    margin-bottom: var(--space-minus-smaller);
  }
}
</style>
